import './AddAttendantsModal.scss';
import { QueuesTracks } from '../../../QueueManagementConstants';
export class AddAttendantModalController {
    static $inject = ['application', 'ngToast', '$translate', 'TeamService', 'close', 'attendantsIdentity', 'SegmentService', 'TenantService'];
    constructor(application, ngToast, $translate, TeamService, close, attendantsIdentity, SegmentService, TenantService) {
        'ngInject';
        this.application = application;
        this.ngToast = ngToast;
        this.$translate = $translate;
        this.TeamService = TeamService;
        this.close = close;
        this.attendantsIdentity = attendantsIdentity;
        this.SegmentService = SegmentService;
        this.TenantService = TenantService;
        this.take = 100;
        this.skip = 0;
        this.isSaveDisabled = true;
        this.onChange = (event) => {
            const { detail: { data } } = event;
            this.attendantsEmails = data;
            this.isSaveDisabled = !this.attendantsEmails.some(x => !!x);
        };
        this.init();
    }
    async init() {
        this.trackPayload = { source: QueuesTracks.SOURCE.PORTAL };
        this.isBillablePlanContract = await this.TenantService.checkIfBillableContract();
        await this.getAttendants();
        this.customEventModal();
    }
    customEventModal() {
        document
            .querySelector('#chips-emails')
            .addEventListener('bdsChangeChips', (evt) => this.onChange(evt));
    }
    async getAttendants() {
        let skip = this.skip;
        const { items, total } = await this.TeamService.getAttendants('', skip, this.take);
        let allItems = items;
        while (allItems.length < total) {
            skip += this.take;
            const { items } = await this.TeamService.getAttendants('', skip, this.take);
            allItems = allItems.concat(items);
        }
        this.attendants = allItems;
        const disabledAttendant = await this.$translate.instant('queue-management.attendants.disabled');
        this.optionsData = await this.attendants
            .filter((c) => !this.attendantsIdentity.includes(c.identity))
            .map((c) => ({ value: c.identity, label: c.email, status: (this.isBillablePlanContract && c.isEnabled === false) ? disabledAttendant : '' }));
    }
    async save() {
        this.SegmentService.createBotTrack(QueuesTracks.QUEUE_ATTENDANTS_ASSIGN, this.application, this.trackPayload);
        try {
            this.isLoading = true;
            const response = this.attendantsEmails.map((item) => {
                return this.attendants.find((c) => c.email == item);
            });
            this.close(response);
        }
        catch (e) {
            console.error(e);
            this.ngToast.warning(this.$translate.instant('modules.application.detail.attendance.team.warning'));
        }
        finally {
            this.isLoading = false;
        }
    }
}
AddAttendantModalController.$inject = ['application', 'ngToast', '$translate', 'TeamService', 'close', 'attendantsIdentity', 'SegmentService', 'TenantService'];
